const getTransitionStyles = timeout => {
  return {
    entering: {
		transform: `scale(0)`,
		//transform: `translate3d(-100%, 0, 0)`,	
		opacity: 0.5,	
    },
    entered: {
		transform: `scale(1)`,
		//transform: `translate3d(0, 0, 0)`,
    	transition: `opacity ${timeout}ms ease-in-out, transform ${timeout}ms ease-in-out`,
		opacity: 1,
    },
    exiting: {
		transform: `scale(0)`,
		//transform: `translate3d(0, 0, 0)`,
        transition: `opacity ${timeout}ms ease-in-out, transform ${timeout}ms ease-in-out`,
		opacity: 0,
    },
  }
}

const getTransitionStyle = ({ timeout, status }) =>
  getTransitionStyles(timeout)[status]

export default getTransitionStyle



// WEBPACK FOOTER //
// ./src/utils/getSlideTransition.js